import { IconCalendar } from "@studyplus/boron-ui";
import classNames from "classnames";
import format from "date-fns/format";
import type { FC } from "react";
import styles from "./styles.scss";

type Props = {
  startDate?: Date;
  endDate?: Date;
  isOpen: boolean;
  onClick: () => void;
};

const PLACEHOLDER = "-- / -- / --　〜　-- / -- / --";

const formatDate = (date: Date) => format(date, "yyyy / MM / dd");

export const Controller: FC<Props> = ({
  startDate,
  endDate,
  isOpen,
  onClick,
}) => {
  const hasRange = Boolean(startDate && endDate);

  return (
    <button
      type="button"
      onClick={onClick}
      className={classNames(styles.controller, {
        [styles.controllerOpen]: isOpen,
      })}
      aria-label="データ参照期間を選択"
      aria-haspopup="dialog"
      aria-expanded={isOpen}
    >
      <span
        className={classNames(styles.controllerText, {
          [styles.controllerPlaceholder]: !hasRange,
        })}
      >
        {hasRange && startDate && endDate
          ? `${formatDate(startDate)}　〜　${formatDate(endDate)}`
          : PLACEHOLDER}
      </span>
      <IconCalendar className={styles.controllerIcon} />
    </button>
  );
};
